import { Menu } from 'antd'
import React, { memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './index.module.scss'
import wallet from '@/assets/images/wallet.png'
import record from '@/assets/images/record.png'
import setting from '@/assets/images/setting.png'
import application from '@/assets/images/application.png'
import { ReactComponent as AnalyzeIcon } from '@/assets/icons/analyze.svg'
import { ReactComponent as AnalyzeSelectIcon } from '@/assets/icons/analyze_select.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { AppState } from '@/store/types'
import { WorkspaceMemberModel } from '@/services/apis/user/model'
import { PermissionKeysEnum, UserRoleEnum } from '@/constants/enum'

const Sider = memo(() => {
  const workspaceMember = useSelector<AppState, WorkspaceMemberModel>(
    state => state.user.workspaceMember
  )
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const [isAnalyze, setIsAnalyze] = useState(false)
  useEffect(() => {
    if (location.pathname === '/analyze') {
      setIsAnalyze(true)
    } else {
      setIsAnalyze(false)
    }
  }, [location.pathname])

  const item = [
    {
      icon: <div className={styles.icon} style={{ backgroundImage: `url(${wallet})` }}></div>,
      key: '/wallet',
      label: t('side.wallet'),
    },
    {
      icon: <div className={styles.icon} style={{ backgroundImage: `url(${record})` }}></div>,
      key: '/history',
      label: t('side.history'),
    },
    {
      icon: (
        <div className={styles.icon}>{isAnalyze ? <AnalyzeSelectIcon /> : <AnalyzeIcon />}</div>
      ),
      key: '/analyze',
      label: t('side.analyze'),
      onMouseEnter: () => setIsAnalyze(true),
      onMouseLeave: () => {
        if (location.pathname === '/analyze') return
        setIsAnalyze(false)
      },
    },
    {
      icon: <div className={styles.icon} style={{ backgroundImage: `url(${application})` }}></div>,
      key: '/application',
      label: t('side.application'),
    },
    {
      icon: <div className={styles.icon} style={{ backgroundImage: `url(${setting})` }}></div>,
      key: '/setting',
      label: t('side.settings'),
    },
  ]
  const handleClick = ({ key }: any) => {
    if (location.pathname === key) return
    navigate(`${key}`)

    if (key === '/analyze') {
      setIsAnalyze(true)
    } else {
      setIsAnalyze(false)
    }
  }
  const [select, setSelect] = useState(location.pathname)
  const isShowSetting = () => {
    const { permissions, role } = workspaceMember
    if (!permissions?.length) return false
    return permissions.some(
      ({ permissionKey }) =>
        permissionKey === PermissionKeysEnum.MANAGEMENT_VAULT_TRADE_POLICY ||
        permissionKey === PermissionKeysEnum.MANAGEMENT_VAULT_API_KEY ||
        role !== UserRoleEnum.MEMBER
    )
  }

  const showItem = () => {
    if (isShowSetting()) {
      return item
    } else {
      return item.filter(item => item.key !== '/setting')
    }
  }

  useEffect(() => {
    setSelect(`/${location.pathname.split('/')[1]}`)
  }, [location.pathname])

  return (
    <div className={styles.container}>
      <Menu
        mode="inline"
        items={showItem()}
        onClick={handleClick}
        defaultSelectedKeys={[`${select}`]}
        selectedKeys={[`${select}`]}
      />
    </div>
  )
})

export default Sider
